import { GenericVehicleDetails } from '@finn/ua-vehicle';

const nextWeek = new Date().setDate(new Date().getDate() + 14);
const nextWeekString = new Date(nextWeek).toISOString();

export const ELECTRIC_SUV_FAKE_PRODUCT = {
  availability: 118,
  available_from_deviation_in_weeks: 0,
  available_from: nextWeekString,
  available_states: null,
  available_terms: [12, 24],
  available_to: '2026-02-17',
  related_configs: [],
  fake_door_filters: 'hyundai.skoda.kia_ioniq-5_enyaq_ev6',
  color_list: [
    {
      availability: 125,
      availability_date: '2025-07-02',
      brand: 'Hyundai',
      car_id: 'hyundai-ioniq5-21816-ecotronicgray',
      color_hex: '#8e9497',
      color_specific: 'Schwarz, Weiß oder Silber',
      desktop_sorting: 2191505,
      id: 'Hellgrau',
      model: 'IONIQ 5',
      picture_front_url:
        'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/fleet_blue_dragon/car_images/image/SSBTcI.png',
      pricing: [517],
      sorting: '2025-07-02-21816',
      uid: 21816,
    },
  ],
  downpayment_prices: {
    available_price_list: {
      b2c_12: 499,
      b2b_12: 412,
      b2c_24: 459,
      b2b_24: 379,
    },
    msrp: 52910,
    extra_km_price: 0.36,
    extra_500: 0,
    extra_1000: 19,
    extra_1500: 109,
    extra_2000: 199,
    extra_2500: 279,
    extra_3000: 369,
    extra_4000: 539,
    extra_5000: 709,
    downpayment_fixed_amount: 1500,
    downpayment_discount_percentage: 3,
  },
  price: {
    available_price_list: {
      b2c_6: 772,
      b2b_6: 649,
      b2c_12: 561,
      b2b_12: 472,
      b2c_24: 517,
      b2b_24: 435,
      b2c_36: 501,
      b2b_36: 414,
    },
    msrp: 52910,
    extra_km_price: 0.36,
    b2c_6: 772,
    b2b_6: 649,
    b2c_12: 561,
    b2b_12: 472,
    b2c_18: 528,
    b2b_18: 444,
    b2c_24: 517,
    b2b_24: 435,
    extra_500: 0,
    extra_1000: 19,
    extra_1500: 109,
    extra_2000: 199,
    extra_2500: 279,
    extra_3000: 369,
    extra_4000: 539,
    extra_5000: 709,
  },
  default_term: 24,
  default_downpayment_term: 24,
  availability_by_term: {
    '12': {
      available_from: nextWeekString,
      available_to: '2026-02-17T00:00:00.000Z',
      deviation_in_weeks: 0,
    },
    '24': {
      available_from: nextWeekString,
      available_to: '2026-02-17T00:00:00.000Z',
      deviation_in_weeks: 0,
    },
  },
  brand: {
    id: 'Hyundai',
    picture: {
      filename: 'Hyundai.svg',
      size: 2095,
      url: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/ua_main_restapi_de/brands/logo/OAR57R.svg',
      type: 'image/svg+xml',
    },
    helper_brand_logo: {
      filename: 'Hyundai.svg',
      size: 2095,
      url: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/ua_main_restapi_de/brands/logo/OAR57R.svg',
      type: 'image/svg+xml',
    },
  },
  cartype: 'Elektro SUV',
  co2emission: null,
  co2_class: 'A',
  color: {
    color_hex: '#000000',
    id: 'Schwarz',
    specific: 'Schwarz, Weiß oder Silber',
  },
  config: {
    link: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/fleet_blue_dragon/configs/attachment/9AeKcz.pdf',
    name: 'attachment.pdf',
  },
  config_drive: 'Heckantrieb',
  config_hitch: null,
  config_id: 21446,
  consumption: 16,
  consumption_city: null,
  consumption_highway: null,
  delivery_options: 'delivery',
  depreciation: null,
  description: 'Kia EV6 oder Skoda Enyaq',
  doors: '5',
  efficiency_class: null,
  efficiency_image: null,
  energy_class_file: null,
  engine: 'Oder ähnlich',
  equipment: {
    comfort:
      'Einparkhilfe vorne Sensor٫ Einparkhilfe hinten Sensor & Kamera, Navigationssystem mit Bedienung über Touch Screen٫ Datenquelle: Internet (Farbe)٫ 12٫30 Zoll-Bildschirm٫ Verkehrsinformation und Verkehrsinfo Monate inklusive: 60, Einparkassistent hinten und Hilfslinien, Intelligenter Geschwindigkeitsassistent, Elektrische Heckklappe',
    exterior:
      'LED Hauptscheinwerfer mit Ellipsoid-Streuscheibe LED, LED Licht Bremslicht٫ Abblendlicht٫ Blinker٫ Tagfahrlicht٫ Rückleuchten und Fernlicht',
    safety:
      'Bremsassistent, Berganfahrassistent / Auto Hold, Spurassistent aktiviert Lenkung, Autonomes Fahren 2 - teilautomatisiert٫ aktive Spurkontrolle٫ Verkehrszeichenerkennung und Autobahn Assistent',
  },
  equipment_delimiter: ', ',
  equipment_line: 'Oder ähnlich',
  equipment_packages: null,
  ev_range: '570',
  financing_type: 'abs_2',
  fuel: 'Elektro',
  gearshift: 'Automatik',
  gross_capitalized_cost: null,
  has_hitch: 'false',
  has_real_pictures: false,
  id: 'category-electric-suv',
  indexable: true,
  model: 'IONIQ 5',
  model_year: '2025',
  offer_type: 'subscription',
  picture: {
    url: 'https://res.cloudinary.com/finn-auto/image/upload/v1747916320/h9lr951l9dmalmthdw7k.png',
  },
  pictures: [
    {
      url: 'https://res.cloudinary.com/finn-auto/image/upload/v1747916320/h9lr951l9dmalmthdw7k.png',
    },
    {
      url: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/fleet_blue_dragon/car_images/image/10A3R-.png',
    },
    {
      url: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/fleet_blue_dragon/car_images/image/mzAVXN.png',
    },
    {
      url: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/fleet_blue_dragon/car_images/image/-nMu_1.png',
    },
    {
      url: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/fleet_blue_dragon/car_images/image/CJyjfB.png',
    },
    {
      url: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/fleet_blue_dragon/car_images/image/6xsmON.png',
    },
    {
      url: 'https://dataops-nocodb-s3-bucket-production.s3.eu-central-1.amazonaws.com/nc/uploads/noco/fleet_blue_dragon/car_images/image/gaVFCJ.png',
    },
  ],
  power: 168,
  product_desktop_sorting: 1843124,
  product_group: ['loyaltyprogram', 'b2b'],
  product_label: {
    label: null,
    label_color: null,
    label_inverted: null,
    label_text_color: null,
  },
  product_path: null,
  product_stock_preorder: null,
  product_stock_total: 118,
  product_stock_webflow: 118,
  purchasing_deal_name: null,
  recurrent_payment_method_list: ['stripe_credit_card', 'stripe_debit_sepa'],
  residual_values: null,
  seats: '5',
  seo_canonical_product_id: null,
  single_payment_method_list: ['stripe_credit_card', 'stripe_debit_sepa'],
  source: 'blue_dragon',
  states_stock: null,
  tires: 'all_season',
  trim_name: 'Oder ähnlich',
  uid: 21446,
} as unknown as GenericVehicleDetails;
